import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import * as React from 'react';
import Animate from 'rc-animate';
import Icon from '../icon';
import Tooltip from '../tooltip';
import Progress from '../progress';
import classNames from 'classnames';
// https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
var previewFile = function previewFile(file, callback) {
  var reader = new FileReader();
  reader.onloadend = function () {
    return callback(reader.result);
  };
  reader.readAsDataURL(file);
};
var extname = function extname(url) {
  if (!url) {
    return '';
  }
  var temp = url.split('/');
  var filename = temp[temp.length - 1];
  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
};
var imageTypes = ['image', 'webp', 'png', 'svg', 'gif', 'jpg', 'jpeg', 'bmp'];
var isImageUrl = function isImageUrl(file) {
  if (imageTypes.includes(file.type)) {
    return true;
  }
  var url = file.thumbUrl || file.url;
  var extension = extname(url);
  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|bmp)$/i.test(extension)) {
    return true;
  } else if (/^data:/.test(url)) {
    // other file types of base64
    return false;
  } else if (extension) {
    // other file types which have extension
    return false;
  }
  return true;
};
var UploadList = function (_React$Component) {
  _inherits(UploadList, _React$Component);
  function UploadList() {
    _classCallCheck(this, UploadList);
    var _this = _possibleConstructorReturn(this, (UploadList.__proto__ || Object.getPrototypeOf(UploadList)).apply(this, arguments));
    _this.handleClose = function (file) {
      var onRemove = _this.props.onRemove;
      if (onRemove) {
        onRemove(file);
      }
    };
    _this.handlePreview = function (file, e) {
      var onPreview = _this.props.onPreview;
      if (!onPreview) {
        return;
      }
      e.preventDefault();
      return onPreview(file);
    };
    return _this;
  }
  _createClass(UploadList, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;
      if (this.props.listType !== 'picture' && this.props.listType !== 'picture-card') {
        return;
      }
      (this.props.items || []).forEach(function (file) {
        if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File) || file.thumbUrl !== undefined) {
          return;
        }
        /*eslint-disable */
        file.thumbUrl = '';
        /*eslint-enable */
        previewFile(file.originFileObj, function (previewDataUrl) {
          /*eslint-disable */
          file.thumbUrl = previewDataUrl;
          /*eslint-enable */
          _this2.forceUpdate();
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this,
        _classNames2;
      var _props = this.props,
        prefixCls = _props.prefixCls,
        _props$items = _props.items,
        items = _props$items === undefined ? [] : _props$items,
        listType = _props.listType,
        showPreviewIcon = _props.showPreviewIcon,
        showRemoveIcon = _props.showRemoveIcon,
        locale = _props.locale;
      var list = items.map(function (file) {
        var _classNames;
        var progress = void 0;
        var icon = React.createElement(Icon, {
          type: file.status === 'uploading' ? 'loading' : 'paper-clip'
        });
        if (listType === 'picture' || listType === 'picture-card') {
          if (listType === 'picture-card' && file.status === 'uploading') {
            icon = React.createElement('div', {
              className: prefixCls + '-list-item-uploading-text'
            }, locale.uploading);
          } else if (!file.thumbUrl && !file.url) {
            icon = React.createElement(Icon, {
              className: prefixCls + '-list-item-thumbnail',
              type: 'picture'
            });
          } else {
            var thumbnail = isImageUrl(file) ? React.createElement('img', {
              src: file.thumbUrl || file.url,
              alt: file.name
            }) : React.createElement(Icon, {
              type: 'file',
              className: prefixCls + '-list-item-icon'
            });
            icon = React.createElement('a', {
              className: prefixCls + '-list-item-thumbnail',
              onClick: function onClick(e) {
                return _this3.handlePreview(file, e);
              },
              href: file.url || file.thumbUrl,
              target: '_blank',
              rel: 'noopener noreferrer'
            }, thumbnail);
          }
        }
        if (file.status === 'uploading') {
          // show loading icon if upload progress listener is disabled
          var loadingProgress = 'percent' in file ? React.createElement(Progress, _extends({
            type: 'line'
          }, _this3.props.progressAttr, {
            percent: file.percent
          })) : null;
          progress = React.createElement('div', {
            className: prefixCls + '-list-item-progress',
            key: 'progress'
          }, loadingProgress);
        }
        var infoUploadingClass = classNames((_classNames = {}, _defineProperty(_classNames, prefixCls + '-list-item', true), _defineProperty(_classNames, prefixCls + '-list-item-' + file.status, true), _classNames));
        var preview = file.url ? React.createElement('a', _extends({}, file.linkProps, {
          href: file.url,
          target: '_blank',
          rel: 'noopener noreferrer',
          className: prefixCls + '-list-item-name',
          onClick: function onClick(e) {
            return _this3.handlePreview(file, e);
          },
          title: file.name
        }), file.name) : React.createElement('span', {
          className: prefixCls + '-list-item-name',
          onClick: function onClick(e) {
            return _this3.handlePreview(file, e);
          },
          title: file.name
        }, file.name);
        var style = {
          pointerEvents: 'none',
          opacity: 0.5
        };
        var previewIcon = showPreviewIcon ? React.createElement('a', {
          href: file.url || file.thumbUrl,
          target: '_blank',
          rel: 'noopener noreferrer',
          style: file.url || file.thumbUrl ? undefined : style,
          onClick: function onClick(e) {
            return _this3.handlePreview(file, e);
          },
          title: locale.previewFile
        }, React.createElement(Icon, {
          type: 'eye-o'
        })) : null;
        var removeIcon = showRemoveIcon ? React.createElement(Icon, {
          type: 'delete',
          title: locale.removeFile,
          onClick: function onClick() {
            return _this3.handleClose(file);
          }
        }) : null;
        var removeIconClose = showRemoveIcon ? React.createElement(Icon, {
          type: 'close',
          title: locale.removeFile,
          onClick: function onClick() {
            return _this3.handleClose(file);
          }
        }) : null;
        var actions = listType === 'picture-card' && file.status !== 'uploading' ? React.createElement('span', {
          className: prefixCls + '-list-item-actions'
        }, previewIcon, removeIcon) : removeIconClose;
        var message = void 0;
        if (file.response && typeof file.response === 'string') {
          message = file.response;
        } else {
          message = file.error && file.error.statusText || locale.uploadError;
        }
        var iconAndPreview = file.status === 'error' ? React.createElement(Tooltip, {
          title: message
        }, icon, preview) : React.createElement('span', null, icon, preview);
        return React.createElement('div', {
          className: infoUploadingClass,
          key: file.uid
        }, React.createElement('div', {
          className: prefixCls + '-list-item-info'
        }, iconAndPreview), actions, React.createElement(Animate, {
          transitionName: 'fade',
          component: ''
        }, progress));
      });
      var listClassNames = classNames((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-list', true), _defineProperty(_classNames2, prefixCls + '-list-' + listType, true), _classNames2));
      var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
      return React.createElement(Animate, {
        transitionName: prefixCls + '-' + animationDirection,
        component: 'div',
        className: listClassNames
      }, list);
    }
  }]);
  return UploadList;
}(React.Component);
export default UploadList;
UploadList.defaultProps = {
  listType: 'text',
  progressAttr: {
    strokeWidth: 2,
    showInfo: false
  },
  prefixCls: 'ant-upload',
  showRemoveIcon: true,
  showPreviewIcon: true
};